import { getCookieConsentOptions } from './cookie';
var AdobeOptin;
(function (AdobeOptin) {
    AdobeOptin["AdobeAnaytics"] = "aa";
    AdobeOptin["ExperienceCloudID"] = "ecid";
})(AdobeOptin || (AdobeOptin = {}));
/**
 * Oppdater Adobe Opt-in Service med brukerens cookie-samtykker.
 *
 * Dersom bruker har samtykket til analyse-cookies, kan Adobe Analytics spore brukerens aktivitet.
 *
 * @param options Brukerens cookie-samtykker
 */
export const setAdobeAnalyticsConsent = (options) => {
    if (!window.__adobe__?.optIn) {
        return;
    }
    if (options.AnalyticsCookies) {
        window.__adobe__.optIn.approve([AdobeOptin.AdobeAnaytics, AdobeOptin.ExperienceCloudID]);
    }
    else {
        window.__adobe__.optIn.deny([AdobeOptin.AdobeAnaytics, AdobeOptin.ExperienceCloudID]);
    }
};
/**
 * Oppdater Adobe Opt-in Service med brukerens cookie-samtykker.
 */
export const updateAdobeAnalyticsConsent = () => {
    const options = getCookieConsentOptions();
    setAdobeAnalyticsConsent(options);
};
